export const APPLICATION_CONNECTED = 'APPLICATION_CONNECTED';
export const APPLICATION_DISCONNECTED = 'APPLICATION_DISCONNECTED';